import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { env } from '@amfam/environment';
import { PolicySummary } from '@amfam/policy/models/lib/models/policy-summary';
import { UmbrellaPolicy } from '@amfam/policy/models/lib/models/umbrella-policy';
import { PolicySharedService } from '@amfam/policy/shared/lib/services/policy-shared.service';

import { TypedWorker } from './typed-worker';

@Injectable({
  providedIn: 'root'
})
export class PlumbrellaService implements TypedWorker {
  private http = inject(HttpClient);
  private policySharedService = inject(PolicySharedService);

  public getEndpoint() {
    return env.policyExperienceApi + 'product/plumbrellapolicies/';
  }

  public getPolicy(url: string, policySummary: PolicySummary): Observable<UmbrellaPolicy> {
    const headers = this.policySharedService.getPolicyPartnerIdHeader(
      policySummary.policyPartnerId
    );
    return this.http
      .get(url, { headers })
      .pipe(map((data: unknown) => this.loadModel(data, policySummary)));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public loadModel(json: any, policySummary: PolicySummary): UmbrellaPolicy {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let policy: any = json;
    if (json.policy) {
      policy = json.policy;
    }
    return new UmbrellaPolicy({ ...policy, sourceSystem: policySummary.sourcePath });
  }
}
